import { IDailyResortLiftTickets } from 'api/resort/types';
import { IGridColumn } from 'components/common/Grid/types';
import { I18nKey } from 'i18n/types';
import { useOTSTranslation } from 'i18n/useOTSTranslation';
import { formatDateFromStr } from 'util/formatDate';
import { passTypes, ticketsTypes, TicketsTypesEnum } from './constants';
import { IDailyGridDataRow } from './restructureDailyGridData';

import styles from './styles.module.scss';

export const generateDailyGridColumns = (dailyLiftTickets: IDailyResortLiftTickets) => {
  const { t } = useOTSTranslation('common');

  const defaultColumns: IGridColumn[] = [{
    header: {
      cellRender: () => (
        <span>
          {`${t('resort.liftTickets.lastUpdated')} `}
          {formatDateFromStr(dailyLiftTickets.lastModified || undefined, 'DD')}
        </span>
      ),
    },
    cellRender: (data: IDailyGridDataRow) => (
      <span>
        <span>{t(data.passType as I18nKeyGenerated['common'])}</span>
      </span>
    ),
    className: styles.dailyTitleCell,
  }];

  const columns = ticketsTypes.reduce((acc, curr) => {
    const ageKey = `${curr}Age` as keyof IDailyResortLiftTickets;
    let columnTitle: string = curr;

    const hasPrices = !!passTypes.filter((type) => {
      const fieldName = type[0].toUpperCase() + type.substring(1);
      return !!dailyLiftTickets[`${curr}${fieldName}Price` as keyof IDailyResortLiftTickets];
    }).length;

    if (curr === TicketsTypesEnum.children) { columnTitle = 'child'; }
    if (curr === TicketsTypesEnum.teenager) { columnTitle = 'junior'; }

    if (hasPrices) {
      acc.push({
        header: {
          cellRender: () => (
            <span>
              <span>{t(`resort.liftTickets.${columnTitle}` as I18nKey['common'])}</span>
              <span>
                {/* https://github.com/i18next/react-i18next/issues/1700 */}
                {/* @ts-ignore */}
                {dailyLiftTickets[ageKey]
                  ? dailyLiftTickets[ageKey]
                  : ''}
              </span>
            </span>
          ),
          className: styles.header,
        },
        dataKey: curr,
      });
    }

    return acc;
  }, defaultColumns);

  return columns;
};
